import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import useAnalyticStore from '../analyticStore/useAnalyticStore';
import useApiStore from '../apiStore/useApiStore';
import useParameterStore from '../parameterStore/useParameterStore';
import { keysToPersist, mailCodeStore } from './mailCodeStore';

const useMailCodeStore = createStore({
  creator: mailCodeStore({
    useAnalyticStore: lazyDependency(() => useAnalyticStore),
    useApiStore: lazyDependency(() => useApiStore),
    useParameterStore: lazyDependency(() => useParameterStore),
  }),
  id: 'mailCode',
  middlewares: {
    devtools: true,
    persist: {
      partialize: (state) => pickState(state, keysToPersist),
    },
  },
  persistHMR: true,
});

export default useMailCodeStore;
